import { render } from "./COIHistory.vue?vue&type=template&id=7e2b94d2"
import script from "./COIHistory.vue?vue&type=script&lang=js"
export * from "./COIHistory.vue?vue&type=script&lang=js"

import "./COIHistory.vue?vue&type=style&index=0&id=7e2b94d2&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__